import {
  AdminAccountControllerGetAllQueryParams,
  useAdminAccountControllerGetAll,
} from "service";

const useTeamMembers = (
  organizationId: string,
  sortQueryParams: Pick<
    AdminAccountControllerGetAllQueryParams,
    "sort" | "order"
  > = {},
) => {
  const { data, isLoading, isError, refetch } = useAdminAccountControllerGetAll(
    { queryParams: { organizationId, ...sortQueryParams } },
  );

  return {
    members: data?.data ?? [],
    isLoading,
    isError,
    refetch,
  };
};

export default useTeamMembers;
